<template lang="pug">
  div(v-if="active")
    slot
</template>

<script>
  export default {
    name: 'SwTab',
    props: {
      title: {
        type: String,
        required: true,
      },
      imagePath: {
        type: String,
        default: '',
        validator: value => value ? value.endsWith('.svg') : true,
      },
    },
    data () {
      return {
        active: {
          type: Boolean,
          default: false,
        },
      };
    },
  };
</script>
